import { formatCostCenterRole } from "../../utils/directorFormat";

const DirectorFilters = ({
  metadata = {},
  period = {},
  filters = {},
  onPeriodChange,
  onFiltersChange,
}) => {
  const entities = metadata.legalEntities || [];
  const projects = (metadata.projects || []).filter((project) => (
    filters.legalEntityId === null
    || filters.legalEntityId === undefined
    || String(project.legalEntityId) === String(filters.legalEntityId)
  ));
  const centers = (metadata.costCenters || []).filter((center) => (
    (filters.legalEntityId === null
      || filters.legalEntityId === undefined
      || String(center.legalEntityId) === String(filters.legalEntityId))
    && (filters.projectKey === null
      || filters.projectKey === undefined
      || center.projectKey === filters.projectKey)
  ));
  const selected = (items, value, key) => (
    items.find((item) => String(item[key]) === String(value))?.[key] ?? null
  );

  return <section className="director-filters" aria-label="Filtros da visão diretoria">
    <div className="director-filter-field">
      <label htmlFor="director-period-from">De</label>
      <input
        id="director-period-from"
        type="month"
        value={period.from ?? ""}
        onChange={(event) => {
          const from = event.target.value;
          if (!from) return;
          onPeriodChange?.({
            from,
            to: period.to && from <= period.to ? period.to : from,
          });
        }}
      />
    </div>
    <div className="director-filter-field">
      <label htmlFor="director-period-to">Até</label>
      <input
        id="director-period-to"
        type="month"
        value={period.to ?? ""}
        onChange={(event) => {
          const to = event.target.value;
          if (!to) return;
          onPeriodChange?.({
            from: period.from && to >= period.from ? period.from : to,
            to,
          });
        }}
      />
    </div>
    <div className="director-filter-field">
      <label htmlFor="director-entity">Empresa jurídica</label>
      <select
        id="director-entity"
        value={filters.legalEntityId ?? ""}
        onChange={(event) => onFiltersChange?.({
          ...filters,
          legalEntityId: selected(entities, event.target.value, "id"),
          projectKey: null,
          costCenterId: null,
        })}
      >
        <option value="">Todas</option>
        {entities.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>
    </div>
    <div className="director-filter-field">
      <label htmlFor="director-project">Projeto</label>
      <select
        id="director-project"
        value={filters.projectKey ?? ""}
        onChange={(event) => onFiltersChange?.({
          ...filters,
          projectKey: event.target.value || null,
          costCenterId: null,
        })}
      >
        <option value="">Todos</option>
        {projects.map((item) => <option key={item.key} value={item.key}>{item.name}</option>)}
      </select>
    </div>
    <div className="director-filter-field">
      <label htmlFor="director-center">Centro de custo</label>
      <select
        id="director-center"
        value={filters.costCenterId ?? ""}
        onChange={(event) => onFiltersChange?.({
          ...filters,
          costCenterId: selected(centers, event.target.value, "id"),
        })}
      >
        <option value="">Todos</option>
        {centers.map((item) => <option key={`${item.projectKey}-${item.id}`} value={item.id}>
          {item.name || formatCostCenterRole(item.role || String(item.id))}
        </option>)}
      </select>
    </div>
  </section>;
};

export default DirectorFilters;
